import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/app/crm/projects")({
  ssr: false,
  head: () => ({ meta: [{ title: "Projekte" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: () => <Outlet />,
});
